<div class="form-horizontal">
  <h3>{{ 'events.settings.reminder.title' | translate | titlecase }}</h3>
  <p>
    {{ 'events.settings.reminder.event-timezone-reminder-note' | translate }}
    (<span *ngIf="eventTimeZone" style="font-weight: bold">{{ eventTimeZone.ShortName }}</span
    >)
  </p>
  <div class="row form-row">
    <div class="col-sm-12">
      <button
        app-add-button
        class="atlas-btn atlas-btn-primary"
        [label]="'events.settings.reminder.button-add-new-reminder' | translate | titlecase"
        [disabled]="loading"
        (click)="newReminder()"
      ></button>
    </div>
  </div>

  <!-- Grid -->
  <div class="row form-row" [hidden]="reminders?.length == 0" [wl-busy-overlay]="loading">
    <div class="col-sm-12">
      <p-table [showGridlines]="true" #remindersDataGrid [rows]="100" [value]="reminders" [hidden]="loading">
        <ng-template pTemplate="header">
          <tr>
            <th>
              {{ 'events.settings.reminder.grid-column-send-date' | translate | titlecase }}
              <span *ngIf="eventTimeZone">{{ eventTimeZone.Abbreviation }}</span>
            </th>
            <th>
              {{ 'events.settings.reminder.grid-column-send-time' | translate | titlecase }}
              <span *ngIf="eventTimeZone">{{ eventTimeZone.Abbreviation }}</span>
            </th>
            <th>
              {{ 'events.settings.reminder.grid-column-subject' | translate | titlecase }}
            </th>
            <th style="width: 200px"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-reminder>
          <tr>
            <td>{{ reminder.SendDate | date: 'M/d/yyyy' }}</td>
            <td>{{ reminder.SendTime }}</td>
            <td>{{ reminder.Subject }}</td>
            <td class="t-ac" [hidden]="reminder.MessageSent">
              <button
                pButton
                type="button"
                class="atlas-btn atlas-btn-default"
                icon="pi pi-pencil"
                [label]="'common.edit' | translate | titlecase"
                (click)="openEditDialog(reminder)"
              ></button>

              <button
                pButton
                type="button"
                class="atlas-btn atlas-btn-danger"
                icon="pi pi-trash"
                [label]="'common.delete' | translate | titlecase"
                (click)="openDeleteDialog(reminder)"
              ></button>
            </td>
            <td class="t-ac" [hidden]="!reminder.MessageSent">
              <span class="green-text">{{ 'events.settings.reminder.reminder-sent' | translate | titlecase }}</span>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-progressSpinner *ngIf="loading"></p-progressSpinner>
    </div>
  </div>
</div>

<!-- Create/Edit modal -->
<wl-event-v4-settings-notification-reminder-edit-dialog
  (reminderSaved)="onReminderSaved()"
  [eventTimeZone]="eventTimeZone"
  [eventDate]="event?.StartDate"
></wl-event-v4-settings-notification-reminder-edit-dialog>

<!-- Delete modal -->
<p-dialog
  #reminderDeleteConfirmationModal
  modal="true"
  [(visible)]="showDeleteModal"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <p>
    {{ 'events.settings.reminder.delete-prompt' | translate }}
  </p>
  <ng-template pTemplate="footer">
    <div>
      <wl-busy [show]="deleting"></wl-busy>
      <cancel-button [label]="'common.cancel' | translate | titlecase" [disabled]="deleting" (onClick)="showDeleteModal = false">
      </cancel-button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-danger"
        [disabled]="deleting"
        (click)="deleteReminder()"
        [icon]="deleting ? '' : 'pi pi-trash'"
        [label]="(deleting ? 'common.deleting' : 'common.delete') | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>
